<template>
    <div class="mx-auto w-full max-w-screen-3xl">
        <div class="p-3.5 md:p-6 flex flex-row justify-end">
            <span class="flex grow"></span>

            <next-button v-if="!isPersonalizeStep && !isMobile" />
        </div>

        <progress-bar v-if="!isPersonalizeStep && !isReviewStep" />
    </div>
</template>

<script>
    import * as constants from '../constants';
    import allStores from '../stores/all';

    import NextButton from './NextButton.vue';
    import ProgressBar from './ProgressBar.vue';

    export default {
        mixins: [allStores],

        components: {
            NextButton,
            ProgressBar,
        },

        computed: {
            isPersonalizeStep() {
                return this.appStore.currentStep === constants.STEP_PERSONALIZE;
            },

            isReviewStep() {
                return this.appStore.currentStep === constants.STEP_REVIEW;
            },

            isMobile() {
                return this.appStore.isMobile;
            },
        },
    };
</script>
